const urls = {
  cdn: 'https://d35mqzen1fcwfi.cloudfront.net', // new
  //cdn: 'https://d2j4aq9mja0i3a.cloudfront.net', // legionhq
  api: 'https://api.legionlistbuilder.com:3001',
  listPath: 'https://legionlistbuilder.com/list'
};


export default urls;
